import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CheckboxOptions } from "@/models/checkbox-button/checkbox-button.interface";
import { utils } from "@/utils/utils";

@Component({
  name: "b-form-checkbox",
})
export default class CheckboxButtonComponent extends Vue {
  public selectedValue!: [];
  public checkedData = "";
  public isDisable = false;

  // ----------------------------------------------------------------
  //   Properties;
  @Prop()
  public options!: CheckboxOptions[];
  @Prop()
  public value!: [];
  @Prop()
  public formType!: string;
  @Prop()
  public editForm!: boolean;

  public checked() {
    this.$emit("input", this.selectedValue);
  }
  public created() {
    this.selectedValue = this.value;
    this.isDisable = utils.disableField(this.editForm, this.formType);
  }

  public updated() {
    this.$emit("input", this.selectedValue);
  }
}
